import React, { type FC } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CorePanelFooter from "../layout/CorePanelFooter";
import CoreLayout from "../layout/CoreLayout";
import { useModal } from "../../hooks/useModal";
import Button from "../form/Button";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {
	cancelSession: () => void;
}

const MfaProgress: FC<Props> = (props) => {
	const { showModal } = useModal();

	return (
		<CoreLayout>
			<UtilityPanel title="Please wait while we authenticate your PG&E account...">
				<div className="text-xs text-slate-600">This might take a minute.</div>
				<div className="w-full">
					<div className="w-full bg-white relative overflow-hidden">
						<div
							className="w-full inline-block h-2 bg-white relative overflow-hidden animate-stripe"
							style={{
								backgroundImage:
									"linear-gradient(45deg, #00A5DF 25%, transparent 25%, transparent 50%, #00A5DF 50%, #00A5DF 75%, transparent 75%, transparent)",
								fontSize: 30,
								backgroundSize: "1em 1em",
								boxSizing: "border-box",
							}}
						/>
					</div>
				</div>
			</UtilityPanel>
			<CorePanelFooter>
				<Button
					onClick={() =>
						showModal(
							"cancel",
							"Are you sure you want to cancel?",
							"Cancelling will end the authorization process.",
							props.cancelSession,
						)
					}
					type="primary"
					subType="outline"
				>
					Cancel
				</Button>
			</CorePanelFooter>
		</CoreLayout>
	);
};

export default withErrorBoundary(MfaProgress);
